import { render, staticRenderFns } from "./importExcel.vue?vue&type=template&id=33c72920&scoped=true&"
import script from "./importExcel.vue?vue&type=script&lang=js&"
export * from "./importExcel.vue?vue&type=script&lang=js&"
import style0 from "./importExcel.vue?vue&type=style&index=0&id=33c72920&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c72920",
  null
  
)

export default component.exports